import About from "../pages/About/About";
import Login from "../pages/Auth/Login";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import Profile from "../pages/Profile/Profile";
import OnBoardingPage from "../pages/OnboardingPage/OnBoardingPage";
import DashboardReport from "../pages/DashboardReport/DashboardReport";
import PrimaryPointAllDealerReport from "../pages/PrimaryPointAllDealerReport/PrimaryPointAllDealerReport";
import WhatsNew from "../pages/WhatsNew/WhatsNew";
import ContactUs from "../pages/ContactUs/ContactUs";
import SpecialEngagement from "../pages/SpecialEngagement/SpecialEngagement";

// import Dashboard from '../pages/Dashboard/Dashboard';
import AddOfftakeEntry from "../pages/OfftakeEntry/AddOfftakeEntry";
import OfftakeEntriesVerificationStatus from "../pages/OfftakeEntry/OfftakeEntriesVerificationStatus";
import OfftakeEntriesVerificationStatusFM from "../pages/OfftakeEntryFM/OfftakeEntriesVerificationStatusFM";
import EditOfftakeEntry from "../pages/OfftakeEntry/EditOfftakeEntry";
import InvoiceVerification from "../pages/FleetManager/InvoiceVerification";
import IndirectBillingReport from "../pages/FleetManager/IndirectBillingReport";
import IndirectBillingReportMonthWise from "../pages/FleetManager/IndirectBillingReportMonthWise";
import FleetDetails from "../pages/FleetManager/FleetDetails";
import SalesReport from "../pages/SalesReport/SalesReport";
import MemberSalesDetail from "../pages/SalesReport/MemberSalesDetail";
import TargetSalesZfm from "../pages/TargetSalesZFM/TargetSalesZFM";
import EnrollNewFleet from "../pages/EnrollNewFleet/EnrollNewFleet";
import NewFleetRegistration from "../pages/NewFleetRegistration/NewFleetRegistration";
import InvitedFleet from "../pages/InvitedFleet/InvitedFleet";
import ActivityReport from "../pages/ActivityReport/ActivityReport";
import SetActivityTarget from "../pages/SetActivityTarget/SetActivityTarget";
import HoDashboard from "../pages/HoDashboard/HoDashboard";
import GiftCatalog from "../pages/GiftCatalog/GiftCatalog";
import GiftItemDetail from "../pages/GiftItem/GiftItemDetail";
import { Permissions } from "../constants/constant.permissions";
import { Roles } from "../constants/constant.role";
import CipSummary from "../pages/CipSummary/CipSummary";
import CipRegitration from "../pages/CipRegitration/CipRegitration";
import CipDetail from "../pages/CipDetail/CipDetail";

export const publicRouteObj = [
  {
    exact: true,
    path: "/login",
    component: Login,
    key: "Login",
    sidenav: false,
    header: false,
  },
  {
    exact: true,
    path: "/forgot-password",
    component: ForgotPassword,
    key: "ForgotPassword",
    sidenav: false,
    header: false,
  },
  {
    exact: true,
    path: "/change-password",
    component: ChangePassword,
    key: "ChangePassword",
    sidenav: false,
    header: false,
  },
  {
    exact: true,
    path: "/invited-fleet",
    component: InvitedFleet,
    key: "InvitedFleet",
    sidenav: false,
    header: false,
  },
  // {
  //   exact: true,
  //   path: '/primary-points-report',
  //   component: PrimaryPointsReport,
  //   key: 'PrimaryPointsReport',
  //   sidenav: true,
  //   header: true
  // },
];

export const privateRouteObj = [
  {
    exact: true,
    path: "/about",
    component: About,
    key: "About",
    sidenav: true,
    header: true,
    isPrivateAndPublic: true,
    // role: [
    //   Roles.FLEET_ROLE,
    //   Roles.FLEET_MANAGER_ROLE,
    //   Roles.ZONAL_FLEET_MANAGER_ROLE,
    //   Roles.HEAD_OFFICE_BAADSHAH_ROLE,
    // ],
    permission: [Permissions.ABOUT_PROGRAMME_BAADSHAH],
  },
  {
    exact: true,
    path: "/profile",
    component: Profile,
    key: "Profile",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_ROLE, Roles.FLEET_MANAGER_ROLE],
    permission: [Permissions.PROFILE_BAADSHAH],
  },

  // not in menu
  {
    exact: true,
    path: "/fleet-report",
    component: DashboardReport,
    key: "DashboardReport",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_ROLE, Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.POINTS_DASHBOARD_BAADSHAH],
  },
  {
    exact: true,
    path: "/",
    component: DashboardReport,
    key: "DashboardReport",
    sidenav: true,
    header: true,
    // role: [
    //   Roles.FLEET_ROLE,
    //   Roles.FLEET_MANAGER_ROLE,
    //   Roles.ZONAL_FLEET_MANAGER_ROLE,
    //   Roles.HEAD_OFFICE_BAADSHAH_ROLE,
    // ],
    permission: [Permissions.POINTS_DASHBOARD_BAADSHAH],
  },
  {
    exact: true,
    path: "/addEditOfftakeEntry",
    component: AddOfftakeEntry,
    key: "addOfftakeEntry",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_ROLE, Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.ADD_OFFTAKE_ENTRY],
  },

  // not in menu
  {
    exact: true,
    path: "/editOfftakeEntry",
    component: EditOfftakeEntry,
    key: "editOfftakeEntry",
    sidenav: true,
    header: true,
    // role: [
    //   Roles.FLEET_ROLE,
    //   Roles.FLEET_MANAGER_ROLE,
    //   Roles.ZONAL_FLEET_MANAGER_ROLE,
    //   Roles.HEAD_OFFICE_BAADSHAH_ROLE,
    // ],
    permission: [Permissions.EDIT_OFFTAKE_ENTRY],
  },
  {
    exact: true,
    path: "/offtakeEntriesVerificationStatus",
    component: OfftakeEntriesVerificationStatus,
    key: "offtakeEntriesVerificationStatus",
    sidenav: true,
    header: true,
    // role: [
    //   Roles.FLEET_ROLE,
    //   Roles.FLEET_MANAGER_ROLE,
    //   Roles.HEAD_OFFICE_BAADSHAH_ROLE,
    //   Roles.ZONAL_FLEET_MANAGER_ROLE,
    // ],
    permission: [Permissions.OFFTAKE_VERIFICATION_STATUS]
  },

  // not in menu
  {
    exact: true,
    path: "/OfftakeEntriesVerificationStatusFM",
    component: OfftakeEntriesVerificationStatusFM,
    key: "OfftakeEntriesVerificationStatusFM",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [],
  },
  {
    exact: true,
    path: "/report",
    component: PrimaryPointAllDealerReport,
    key: "PrimaryPointAllDealerReport",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE, Roles.HEAD_OFFICE_BAADSHAH_ROLE],
    permission: [Permissions.OFFTAKE_REPORT_BAADSHAH],
  },
  // not in menu
  {
    exact: true,
    path: "/invoiceVerification",
    component: InvoiceVerification,
    key: "invoiceVerification",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.INVOICE_VERIFICATION],
  },
  {
    exact: true,
    path: "/indirectBillingReport",
    component: IndirectBillingReport,
    key: "indirectBillingReport",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.INDIRECT_BILLING_REPORT],
  },

  // Not in menu
  {
    exact: true,
    path: "/indirectBillingReportMonthWise",
    component: IndirectBillingReportMonthWise,
    key: "indirectBillingReportMonthWise",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.INDIRECT_BILLING_REPORT],
  },
  {
    exact: true,
    path: "/fleetDetails",
    component: FleetDetails,
    key: "fleetDetails",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE, Roles.HEAD_OFFICE_BAADSHAH_ROLE],
    permission: [Permissions.FLEET_DETAIL],
  },
  {
    exact: true,
    path: "/whats-new",
    component: WhatsNew,
    key: "",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_ROLE],
    permission: [Permissions.WHATS_NEW_BAADSHAH],
  },
  {
    exact: true,
    path: "/contact-us",
    component: ContactUs,
    key: "ContactUs",
    sidenav: true,
    header: true,
    isPrivateAndPublic: true,
    // role: [
    //   Roles.FLEET_ROLE,
    //   Roles.FLEET_MANAGER_ROLE,
    //   Roles.ZONAL_FLEET_MANAGER_ROLE,
    //   Roles.HEAD_OFFICE_BAADSHAH_ROLE,
    // ],
    permission: [Permissions.CONTACT_US_BAADSHAH],
  },
  {
    exact: true,
    path: "/salesReport",
    component: SalesReport,
    key: "SalesReport",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE, Roles.HEAD_OFFICE_BAADSHAH_ROLE],
    permission: [Permissions.SALES_REPORT],
  },

  // not in menu
  {
    exact: true,
    path: "/memberSalesDetail",
    component: MemberSalesDetail,
    key: "MemberSalesDetail",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.MEMBER_SALE_DETAIL],
  },

  // not in menu
  {
    exact: true,
    path: "/target-sales",
    component: TargetSalesZfm,
    key: "TargetSalesZfm",
    sidenav: true,
    header: true,
    // role: [Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.TARGET_SALES],
  },

  // not in menu
  {
    exact: true,
    path: "/enroll-new-fleet",
    component: EnrollNewFleet,
    key: "EnrollNewFleet",
    sidenav: true,
    header: true,
    isPrivateAndPublic: true,
    // role: [Roles.FLEET_ROLE, Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.ENROLL_FLEET],
  },
  {
    exact: true,
    path: "/new-fleet-registration",
    component: NewFleetRegistration,
    key: "NewFleetRegistration",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_ROLE, Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.NEW_FLEET_REGISTRATION],
  },
  {
    exact: true,
    path: "/activity-report",
    component: ActivityReport,
    key: "ActivityReport",
    sidenav: true,
    header: true,
    // role: [Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE, Roles.HEAD_OFFICE_BAADSHAH_ROLE],
    permission: [Permissions.ACTIVITY_REPORT],
  },

  // not in menu
  {
    exact: true,
    path: "/set-activity-target",
    component: SetActivityTarget,
    key: "SetActivityTarget",
    sidenav: true,
    header: true,
    // role: [Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.SET_ACTIVITY_TARGET],
  },
  // not in menu
  {
    exact: true,
    path: "/special-engagement",
    component: SpecialEngagement,
    key: "SpecialEngagement",
    sidenav: true,
    header: true,
    isPrivateAndPublic: true,
    // role: [Roles.FLEET_ROLE, Roles.FLEET_MANAGER_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.SPECIAL_ENGAGEMENT],
  },
  {
    exact: true,
    path: "/dashboard",
    component: HoDashboard,
    key: "HoDashboard",
    sidenav: true,
    header: true,
    // role: [Roles.HEAD_OFFICE_BAADSHAH_ROLE, Roles.ZONAL_FLEET_MANAGER_ROLE],
    permission: [Permissions.OFFTAKE_DASHBOARD_BAADSHAH],
  },
  {
    exact: true,
    path: "/redemption-catalog",
    component: GiftCatalog,
    key: "",
    sidenav: true,
    header: true,
    // role: [
    //   Roles.HEAD_OFFICE_BAADSHAH_ROLE,
    //   Roles.FLEET_ROLE,
    //   Roles.FLEET_MANAGER_ROLE,
    //   Roles.ZONAL_FLEET_MANAGER_ROLE
    // ],
    permission: [Permissions.REDEMPTION_CATALOGUE],
  },

  // not in menu
  {
    exact: true,
    path: "/product-detail",
    component: GiftItemDetail,
    key: "productDetail",
    sidenav: true,
    header: true,
    // role: [
    //   Roles.HEAD_OFFICE_BAADSHAH_ROLE,
    //   Roles.FLEET_ROLE,
    //   Roles.FLEET_MANAGER_ROLE,
    //   Roles.ZONAL_FLEET_MANAGER_ROLE
    // ],
    permission: [Permissions.REDEMPTION_CATALOGUE],
  },
  {
    exact: true,
    path: "/cip-registration",
    component: CipRegitration,
    key: "",
    sidenav: true,
    header: true,
    permission: [Permissions.CUSTOMER_INTERACTION],
  },
  {
    exact: true,
    path: "/cip-detail",
    component: CipDetail,
    key: "",
    sidenav: true,
    header: true,
    permission: [Permissions.CUSTOMER_INTERACTION],
  },
  {
    exact: true,
    path: "/cip-summary",
    component: CipSummary,
    key: "",
    sidenav: true,
    header: true,
    permission: [Permissions.CUSTOMER_INTERACTION],
  },
];

export const onBoardingRouteObj = [

  // not in menu
  {
    exact: true,
    path: "/on-boarding",
    component: OnBoardingPage,
    key: "OnBoardingPage",
    sidenav: false,
    header: false,
    // role: [Roles.FLEET_ROLE],
  },
];
